export interface SupportingDocumentFileLineData {
	description: string;
	fileName: string;
	fileUrl: string;
	lookupId: string;
}

export class SupportingDocumentFileLineData implements SupportingDocumentFileLineData {
	description = "";
	fileName = "";
	fileUrl = "";
	lookupId = "";

	constructor(data?: Partial<SupportingDocumentFileLineData>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}